'use strict';
import * as $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$0024anon$00241 from "./app.data.-Email-Link-Sign-In-Error$$anon$1.js";
import * as $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$002dInvalid$002dEmail from "./app.data.-Email-Link-Sign-In-Error$-Invalid-Email.js";
import * as $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$002dOther from "./app.data.-Email-Link-Sign-In-Error$-Other.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_data_EmailLinkSignInError$__ExpiredActionCode__Lapp_data_EmailLinkSignInError() {
  $m_Lapp_data_EmailLinkSignInError$();
  return $t_Lapp_data_EmailLinkSignInError$__ExpiredActionCode;
}
export { $s_Lapp_data_EmailLinkSignInError$__ExpiredActionCode__Lapp_data_EmailLinkSignInError as $s_Lapp_data_EmailLinkSignInError$__ExpiredActionCode__Lapp_data_EmailLinkSignInError };
function $s_Lapp_data_EmailLinkSignInError$__EmailNotProvided__Lapp_data_EmailLinkSignInError() {
  $m_Lapp_data_EmailLinkSignInError$();
  return $t_Lapp_data_EmailLinkSignInError$__EmailNotProvided;
}
export { $s_Lapp_data_EmailLinkSignInError$__EmailNotProvided__Lapp_data_EmailLinkSignInError as $s_Lapp_data_EmailLinkSignInError$__EmailNotProvided__Lapp_data_EmailLinkSignInError };
function $s_Lapp_data_EmailLinkSignInError$__UserDisabled__Lapp_data_EmailLinkSignInError() {
  $m_Lapp_data_EmailLinkSignInError$();
  return $t_Lapp_data_EmailLinkSignInError$__UserDisabled;
}
export { $s_Lapp_data_EmailLinkSignInError$__UserDisabled__Lapp_data_EmailLinkSignInError as $s_Lapp_data_EmailLinkSignInError$__UserDisabled__Lapp_data_EmailLinkSignInError };
/** @constructor */
function $c_Lapp_data_EmailLinkSignInError$() {
  $n_Lapp_data_EmailLinkSignInError$ = this;
  $t_Lapp_data_EmailLinkSignInError$__ExpiredActionCode = new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$0024anon$00241.$c_Lapp_data_EmailLinkSignInError$$anon$1("ExpiredActionCode", 0);
  $t_Lapp_data_EmailLinkSignInError$__EmailNotProvided = new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$0024anon$00241.$c_Lapp_data_EmailLinkSignInError$$anon$1("EmailNotProvided", 2);
  $t_Lapp_data_EmailLinkSignInError$__UserDisabled = new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$0024anon$00241.$c_Lapp_data_EmailLinkSignInError$$anon$1("UserDisabled", 3);
}
export { $c_Lapp_data_EmailLinkSignInError$ as $c_Lapp_data_EmailLinkSignInError$ };
$p = $c_Lapp_data_EmailLinkSignInError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_EmailLinkSignInError$;
/** @constructor */
function $h_Lapp_data_EmailLinkSignInError$() {
}
export { $h_Lapp_data_EmailLinkSignInError$ as $h_Lapp_data_EmailLinkSignInError$ };
$h_Lapp_data_EmailLinkSignInError$.prototype = $p;
$p.bJa = (function(providedEmail, err) {
  var msg = err.gw();
  return (((msg.indexOf("auth/invalid-email") | 0) !== (-1)) ? new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$002dInvalid$002dEmail.$c_Lapp_data_EmailLinkSignInError$InvalidEmail(providedEmail) : (((msg.indexOf("auth/user-disabled") | 0) !== (-1)) ? $s_Lapp_data_EmailLinkSignInError$__UserDisabled__Lapp_data_EmailLinkSignInError() : ((((msg.indexOf("auth/expired-action-code") | 0) !== (-1)) || ((msg.indexOf("auth/invalid-action-code") | 0) !== (-1))) ? $s_Lapp_data_EmailLinkSignInError$__ExpiredActionCode__Lapp_data_EmailLinkSignInError() : new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError$0024$002dOther.$c_Lapp_data_EmailLinkSignInError$Other($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_ThrowableExts$package$().a56(err)))));
});
$p.dl = (function(x) {
  return x.co();
});
var $d_Lapp_data_EmailLinkSignInError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_EmailLinkSignInError$, "app.data.EmailLinkSignInError$", ({
  DB: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_EmailLinkSignInError$ as $d_Lapp_data_EmailLinkSignInError$ };
var $n_Lapp_data_EmailLinkSignInError$;
function $m_Lapp_data_EmailLinkSignInError$() {
  if ((!$n_Lapp_data_EmailLinkSignInError$)) {
    $n_Lapp_data_EmailLinkSignInError$ = new $c_Lapp_data_EmailLinkSignInError$();
  }
  return $n_Lapp_data_EmailLinkSignInError$;
}
export { $m_Lapp_data_EmailLinkSignInError$ as $m_Lapp_data_EmailLinkSignInError$ };
var $t_Lapp_data_EmailLinkSignInError$__ExpiredActionCode = null;
function $u_Lapp_data_EmailLinkSignInError$__ExpiredActionCode(x) {
  $t_Lapp_data_EmailLinkSignInError$__ExpiredActionCode = x;
}
export { $t_Lapp_data_EmailLinkSignInError$__ExpiredActionCode as $t_Lapp_data_EmailLinkSignInError$__ExpiredActionCode, $u_Lapp_data_EmailLinkSignInError$__ExpiredActionCode as $u_Lapp_data_EmailLinkSignInError$__ExpiredActionCode };
var $t_Lapp_data_EmailLinkSignInError$__EmailNotProvided = null;
function $u_Lapp_data_EmailLinkSignInError$__EmailNotProvided(x) {
  $t_Lapp_data_EmailLinkSignInError$__EmailNotProvided = x;
}
export { $t_Lapp_data_EmailLinkSignInError$__EmailNotProvided as $t_Lapp_data_EmailLinkSignInError$__EmailNotProvided, $u_Lapp_data_EmailLinkSignInError$__EmailNotProvided as $u_Lapp_data_EmailLinkSignInError$__EmailNotProvided };
var $t_Lapp_data_EmailLinkSignInError$__UserDisabled = null;
function $u_Lapp_data_EmailLinkSignInError$__UserDisabled(x) {
  $t_Lapp_data_EmailLinkSignInError$__UserDisabled = x;
}
export { $t_Lapp_data_EmailLinkSignInError$__UserDisabled as $t_Lapp_data_EmailLinkSignInError$__UserDisabled, $u_Lapp_data_EmailLinkSignInError$__UserDisabled as $u_Lapp_data_EmailLinkSignInError$__UserDisabled };
//# sourceMappingURL=app.data.-Email-Link-Sign-In-Error$.js.map
